import { render } from "./WpeTransfer.vue?vue&type=template&id=4dda2fce"
import script from "./WpeTransfer.vue?vue&type=script&lang=js"
export * from "./WpeTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeTransfer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4dda2fce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4dda2fce', __exports__)) {
    api.reload('4dda2fce', __exports__)
  }
  
  module.hot.accept("./WpeTransfer.vue?vue&type=template&id=4dda2fce", () => {
    api.rerender('4dda2fce', render)
  })

}


export default __exports__